/* CheekyShorts — theme behaviour.
 *
 * Everything the design needs, natively: theme repaint, lineup selection, buy panel swap,
 * bundles, AJAX cart, drawer, size guide, discount popup, sticky bar, FAQ.
 *
 * No dependencies. No app embeds. Apps are why Shopify stores get slow.
 *
 * One rule worth keeping: money shown to the customer always comes from Shopify. Bundle
 * prices in the selector are marketing copy from theme settings; every figure in the cart
 * and the drawer is read back from /cart.js. If an automatic discount is misconfigured, the
 * customer sees the real total rather than the one we hoped for.
 */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var CATALOGUE = readJSON('CatalogueData') || [];
  var CONFIG = readJSON('ShopConfig') || {};
  var BUNDLES = CONFIG.bundles || [];

  /* ---- money ------------------------------------------------------------ */
  /* Mirrors Shopify's money_format tokens so the client never invents a format. */
  function money(cents) {
    var fmt = CONFIG.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      var v = (cents / 100).toFixed(2);
      var whole = Math.round(cents / 100).toString();
      function commas(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      switch (token) {
        case 'amount': return commas(v.split('.')[0]) + '.' + v.split('.')[1];
        case 'amount_no_decimals': return commas(whole);
        case 'amount_with_comma_separator':
          return commas(v.split('.')[0]).replace(/,/g, '.') + ',' + v.split('.')[1];
        case 'amount_no_decimals_with_comma_separator':
          return commas(whole).replace(/,/g, '.');
        default: return v;
      }
    });
  }
  /* Drops ".00" — the shipping sentence reads better as "$12" than "$12.00". */
  function moneyShort(cents) { return money(cents).replace(/[.,]00(?!\d)/, ''); }

  /* ---- state ------------------------------------------------------------ */
  var state = {
    handle: null,
    size: CONFIG.defaultSize || 'L',
    tone: '',
    bundle: 3,
    cart: null
  };

  function product() {
    for (var i = 0; i < CATALOGUE.length; i++) {
      if (CATALOGUE[i].handle === state.handle) return CATALOGUE[i];
    }
    return CATALOGUE[0] || null;
  }
  function bundle() {
    for (var i = 0; i < BUNDLES.length; i++) if (BUNDLES[i].qty === state.bundle) return BUNDLES[i];
    return BUNDLES[BUNDLES.length - 1];
  }
  function variant() {
    var p = product();
    if (!p) return null;
    var wantTone = p.hasTone ? (state.tone || '') : '';
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (v.size !== state.size) continue;
      if (p.hasTone && wantTone && v.tone !== wantTone) continue;
      return v;
    }
    return null;
  }

  /* ---- theme repaint ---------------------------------------------------- */
  /* One attribute swap on <html>. Custom properties do the rest, and the transition is
     limited to colour so nothing triggers layout. */
  function paint(themeKey) {
    if (!themeKey) return;
    document.documentElement.setAttribute('data-theme', themeKey);
  }

  /* ---- buy panel -------------------------------------------------------- */
  function renderBuyPanel() {
    var p = product();
    if (!p) return;
    var panel = $('[data-buy]');

    $$('[data-hero-case]').forEach(function (n) { n.textContent = 'No. ' + p.case; });
    $$('[data-hero-family]').forEach(function (n) { n.textContent = p.family; });
    $$('[data-hero-caption]').forEach(function (n) { n.textContent = 'No. ' + p.case + ' — ' + p.family; });
    $$('[data-hero-view]').forEach(function (n) { n.textContent = p.view; });

    var heroImg = $('[data-hero-img]');
    if (heroImg && p.images[0]) {
      heroImg.src = p.images[0].lg;
      heroImg.srcset = p.images[0].sm + ' 400w, ' + p.images[0].md + ' 800w, ' + p.images[0].lg + ' 1400w';
      heroImg.alt = p.title;
    }

    if (!panel) return;

    var img = $('[data-buy-img]', panel);
    if (img && p.images[0]) {
      img.src = p.images[0].lg;
      img.srcset = p.images[0].md + ' 800w, ' + p.images[0].lg + ' 1400w';
      img.alt = p.title;
    }
    var view = $('[data-buy-view]', panel); if (view) view.textContent = p.view;
    var fam = $('[data-buy-family]', panel); if (fam) fam.textContent = p.family;
    var waist = $('[data-buy-waist]', panel); if (waist) waist.textContent = p.waistband;
    var blurb = $('[data-buy-blurb]', panel); if (blurb) blurb.textContent = p.blurb;
    var price = $('[data-buy-price]', panel); if (price) price.textContent = money(p.price);
    var cmp = $('[data-buy-compare]', panel);
    if (cmp) cmp.textContent = p.compare ? money(p.compare) : '';
    var save = $('[data-buy-save]', panel);
    if (save) {
      if (p.compare && p.compare > p.price) {
        save.hidden = false;
        save.textContent = 'Save ' + Math.round((p.compare - p.price) * 100 / p.compare) + '%';
      } else { save.hidden = true; }
    }

    /* thumbnails */
    var thumbs = $('[data-buy-thumbs]', panel);
    if (thumbs) {
      thumbs.innerHTML = p.images.slice(0, 4).map(function (im, i) {
        return '<button class="thumb" type="button" data-thumb="' + im.lg + '" aria-current="' +
          (i === 0 ? 'true' : 'false') + '" aria-label="View image ' + (i + 1) + '">' +
          '<img src="' + im.sm + '" width="220" height="220" alt="" loading="lazy" decoding="async"></button>';
      }).join('');
    }

    /* skin tone */
    var toneWrap = $('[data-tone-wrap]', panel);
    if (toneWrap) {
      toneWrap.hidden = !p.hasTone;
      if (p.hasTone) {
        var tones = [];
        p.variants.forEach(function (v) { if (v.tone && tones.indexOf(v.tone) === -1) tones.push(v.tone); });
        if (!state.tone || tones.indexOf(state.tone) === -1) state.tone = tones[0] || '';
        var tw = $('[data-tones]', panel);
        if (tw) {
          tw.innerHTML = tones.map(function (t) {
            return '<button class="tone" type="button" data-tone="' + t + '" aria-pressed="' +
              (t === state.tone ? 'true' : 'false') + '">' + t + '</button>';
          }).join('');
        }
      } else {
        state.tone = '';
      }
    }

    /* sizes — mark sold-out variants rather than hiding them */
    $$('[data-sizes] .size', panel).forEach(function (b) {
      var s = b.getAttribute('data-size');
      var found = p.variants.some(function (v) {
        return v.size === s && (!p.hasTone || !state.tone || v.tone === state.tone) && v.available;
      });
      b.disabled = !found;
      b.setAttribute('aria-pressed', s === state.size ? 'true' : 'false');
    });

    syncBundleUI();
    renderSticky();
  }

  function syncBundleUI() {
    var b = bundle();
    $$('[data-bundle]').forEach(function (n) {
      n.setAttribute('aria-pressed', Number(n.getAttribute('data-bundle')) === state.bundle ? 'true' : 'false');
    });
    $$('[data-add-price]').forEach(function (n) { n.textContent = money(b.price); });
    var v = variant();
    $$('[data-add]').forEach(function (n) { n.disabled = !v; });
  }

  function renderSticky() {
    var p = product(); if (!p) return;
    var img = $('[data-sticky-img]');
    if (img && p.images[0]) { img.src = p.images[0].sm; img.alt = ''; }
    var n = $('[data-sticky-name]'); if (n) n.textContent = 'No. ' + p.case + ' · ' + p.family;
    var v = $('[data-sticky-variant]');
    if (v) {
      var b = bundle();
      v.textContent = 'Size ' + state.size + (state.tone ? ' · ' + state.tone : '') + ' · ' + b.title;
    }
  }

  function select(handle, scrollTo) {
    var found = CATALOGUE.some(function (p) { return p.handle === handle; });
    if (!found) return;
    state.handle = handle;
    var p = product();
    paint(p.theme);
    $$('[data-select]').forEach(function (t) {
      if (t.classList.contains('tile')) {
        t.setAttribute('aria-current', t.getAttribute('data-select') === handle ? 'true' : 'false');
      }
    });
    renderBuyPanel();
    if (scrollTo) {
      var el = $(scrollTo);
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
    }
  }

  /* ---- cart ------------------------------------------------------------- */
  function cartFetch(url, opts) {
    return fetch(url, Object.assign({
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin'
    }, opts || {})).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed: ' + r.status);
      return r.json();
    });
  }

  function refreshCart() {
    return cartFetch(CONFIG.routes.cart + '.js').then(function (cart) {
      state.cart = cart;
      renderCart();
      return cart;
    });
  }

  function renderCart() {
    var cart = state.cart;
    if (!cart) return;

    $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });

    var threshold = CONFIG.freeShipThreshold || 5000;
    var toGo = threshold - cart.total_price;
    var note = toGo > 0
      ? 'Spend ' + moneyShort(toGo) + ' more to get free US shipping'
      : 'Free US shipping unlocked';
    $$('[data-ship-note]').forEach(function (n) { n.textContent = note; });
    $$('[data-prog]').forEach(function (n) {
      n.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    });

    var lines = $('[data-cart-lines]');
    if (lines) {
      if (!cart.items.length) {
        lines.innerHTML = '<p class="drawer__empty">Empty. Cowardly.</p>';
      } else {
        lines.innerHTML = cart.items.map(function (i) {
          var cat = CATALOGUE.filter(function (p) { return p.handle === i.handle; })[0];
          var name = (cat && cat.family) || i.product_title;
          var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_128x$1$2') : '';
          return '<div class="line" data-key="' + i.key + '">' +
            '<img src="' + img + '" width="64" height="64" alt="" loading="lazy">' +
            '<div class="line__m">' +
              '<div class="line__n">' + esc(name) + '</div>' +
              '<div class="line__v">' + esc(i.variant_title || '') + ' · ' + i.quantity +
                (i.quantity === 1 ? ' pair' : ' pairs') + '</div>' +
              '<button class="line__rm" type="button" data-remove="' + i.key + '">Remove</button>' +
            '</div>' +
            '<div class="line__p">' + money(i.final_line_price) + '</div>' +
          '</div>';
        }).join('');
      }
    }

    var total = $('[data-cart-total]'); if (total) total.textContent = money(cart.total_price);
    var save = $('[data-cart-save]');
    if (save) {
      save.textContent = cart.total_discount > 0
        ? 'You saved ' + money(cart.total_discount) + '. Taxes at checkout.'
        : 'Taxes calculated at checkout.';
    }
    var co = $('.checkout'); if (co) co.disabled = cart.item_count === 0;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addToCart() {
    var v = variant();
    if (!v) return;
    var qty = bundle().qty;
    var btns = $$('[data-add],[data-add-sticky]');
    btns.forEach(function (b) { b.disabled = true; });

    cartFetch(CONFIG.routes.add + '.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
    })
      .then(refreshCart)
      .then(function () { open('cart'); })
      .catch(function (e) {
        console.error(e);
        alert('Sorry — that could not be added to your bag. Please try again.');
      })
      .then(function () { btns.forEach(function (b) { b.disabled = false; }); syncBundleUI(); });
  }

  function removeLine(key) {
    cartFetch(CONFIG.routes.change + '.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (cart) { state.cart = cart; renderCart(); }).catch(console.error);
  }

  /* ---- overlays --------------------------------------------------------- */
  var openName = null;
  var lastFocus = null;
  var panels = {
    cart: function () { return $('#CartDrawer'); },
    size: function () { return $('#SizeModal'); },
    pop: function () { return $('#DiscountPopup'); }
  };

  function open(name) {
    if (openName) close();
    var el = panels[name] && panels[name]();
    if (!el) return;
    lastFocus = document.activeElement;
    openName = name;
    el.classList.add('is-on');
    el.setAttribute('aria-hidden', 'false');
    var scrim = $('#Scrim');
    if (scrim) {
      scrim.hidden = false;
      /* Force a reflow so the opacity transition has a frame to start from. A rAF would do
         the same on a visible tab, but rAF is throttled when the page is hidden and the
         scrim would then never fade in. */
      void scrim.offsetWidth;
      scrim.classList.add('is-on');
    }
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('button:not([disabled]),input,a[href]');
    if (focusable) focusable.focus();
  }

  function close() {
    if (!openName) return;
    var el = panels[openName]();
    if (el) { el.classList.remove('is-on'); el.setAttribute('aria-hidden', 'true'); }
    var scrim = $('#Scrim');
    if (scrim) {
      scrim.classList.remove('is-on');
      setTimeout(function () { if (!openName) scrim.hidden = true; }, 260);
    }
    document.body.style.overflow = '';
    openName = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---- discount popup --------------------------------------------------- */
  var POP_KEY = 'cs_popup_seen';
  function initPopup() {
    var el = $('#DiscountPopup');
    if (!el) return;
    var seen;
    try { seen = localStorage.getItem(POP_KEY); } catch (e) { seen = '1'; }
    if (seen) return;

    var fired = false;
    function show() {
      if (fired || openName) return;
      fired = true;
      try { localStorage.setItem(POP_KEY, '1'); } catch (e) {}
      open('pop');
      clearTimeout(timer);
      document.removeEventListener('mouseout', onExit);
    }
    var timer = setTimeout(show, CONFIG.popupDelay || 7000);

    /* Exit intent needs a cursor. On touch the timer is the only trigger. */
    function onExit(e) { if (e.clientY <= 0 && !e.relatedTarget) show(); }
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseout', onExit);
    }

    var form = $('[data-pop-form]', el);
    if (form) {
      form.addEventListener('submit', function () {
        /* Let Shopify take the signup, but reveal the code inline first — the modal
           must not close on submit. */
        var code = $('[data-pop-code]', el);
        if (code) code.hidden = false;
        form.hidden = true;
      });
    }
  }

  /* ---- sticky bar ------------------------------------------------------- */
  function initSticky() {
    var bar = $('[data-sticky]');
    if (!bar) return;
    var threshold = CONFIG.stickyAfter || 700;
    var on = false;
    function check() {
      var should = window.scrollY > threshold;
      if (should !== on) { on = should; bar.classList.toggle('is-on', on); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---- wiring ----------------------------------------------------------- */
  function init() {
    /* Bind to whichever product the page already rendered, so the server-side markup and
       the JS state never disagree on first paint. */
    var buy = $('[data-buy]');
    var initial = null;
    if (window.__CS_PRODUCT__) initial = window.__CS_PRODUCT__;
    if (!initial) {
      var firstTile = $('.tile[aria-current="true"]');
      if (firstTile) initial = firstTile.getAttribute('data-select');
    }
    if (!initial && CATALOGUE[0]) initial = CATALOGUE[0].handle;
    state.handle = initial;

    var p = product();
    if (p) {
      paint(p.theme);
      if (p.hasTone) {
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].tone) { state.tone = p.variants[i].tone; break; }
        }
      }
      /* Only re-render the panel when it can actually change product. On a product page the
         server markup is already correct and rewriting it would just cause a flash. */
      if (buy && buy.hasAttribute('data-buy-swappable')) renderBuyPanel();
      else { syncBundleUI(); renderSticky(); }
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-select],[data-open],[data-close],[data-size],[data-tone],[data-bundle],[data-thumb],[data-remove],[data-add],[data-add-sticky],[data-step]');
      if (!t) return;

      if (t.hasAttribute('data-select')) {
        e.preventDefault();
        select(t.getAttribute('data-select'), t.getAttribute('data-scroll'));
        return;
      }
      if (t.hasAttribute('data-open')) { e.preventDefault(); open(t.getAttribute('data-open')); return; }
      if (t.hasAttribute('data-close')) { e.preventDefault(); close(); return; }

      if (t.hasAttribute('data-step')) {
        e.preventDefault();
        var idx = CATALOGUE.findIndex(function (x) { return x.handle === state.handle; });
        var next = (idx + Number(t.getAttribute('data-step')) + CATALOGUE.length) % CATALOGUE.length;
        select(CATALOGUE[next].handle);
        return;
      }
      if (t.hasAttribute('data-size')) {
        state.size = t.getAttribute('data-size');
        $$('[data-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-size') === state.size ? 'true' : 'false');
        });
        syncBundleUI(); renderSticky();
        return;
      }
      if (t.hasAttribute('data-tone')) {
        state.tone = t.getAttribute('data-tone');
        $$('[data-tone]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-tone') === state.tone ? 'true' : 'false');
        });
        renderBuyPanel();
        return;
      }
      if (t.hasAttribute('data-bundle')) { state.bundle = Number(t.getAttribute('data-bundle')); syncBundleUI(); renderSticky(); return; }
      if (t.hasAttribute('data-thumb')) {
        var img = $('[data-buy-img]');
        if (img) img.src = t.getAttribute('data-thumb');
        $$('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
        return;
      }
      if (t.hasAttribute('data-remove')) { e.preventDefault(); removeLine(t.getAttribute('data-remove')); return; }
      if (t.hasAttribute('data-add') || t.hasAttribute('data-add-sticky')) { e.preventDefault(); addToCart(); return; }
    });

    var form = $('[data-buy-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });

    var scrim = $('#Scrim');
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* FAQ glyph — <details> does the rest */
    $$('.faq__row').forEach(function (d) {
      d.addEventListener('toggle', function () {
        var i = d.querySelector('.faq__q i');
        if (i) i.textContent = d.open ? '–' : '+';
      });
    });

    initSticky();
    initPopup();
    refreshCart().catch(function () { /* server-rendered drawer stands */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
